// lib/ab/config.js
// Las pruebas A/B que están corriendo en la web. Este archivo es TODO lo que hay que tocar del
// lado de la web para agregar, cambiar o terminar una.
//
// CÓMO FUNCIONA (el detalle está en script.js e index.js)
// La primera vez que alguien abre una página donde corre una prueba, el navegador sortea una
// variante, la guarda en la cookie `bcm_ab` y le pone a <html> el atributo
// data-ab-<clave>="<variante>" ANTES de que se dibuje la página. Con eso la variante se arma
// con CSS, sin parpadeo:
//
//     html[data-ab-l01="b"] .muestra-arriba { display: block }
//
// o desde un componente, con `variante("l01")` de lib/ab. El que no tiene JavaScript, el que
// bloquea las cookies y los crawlers no entran al sorteo: ven la página de siempre, que tiene
// que ser la variante "a".
//
// PARA AGREGAR UNA PRUEBA
//  1. Una entrada acá abajo. `clave`: 2 a 12 letras minúsculas o números, y no se reusa nunca
//     (los visitantes viejos la tienen en la cookie con la variante de la prueba anterior).
//  2. Una fila en la tabla `ab_tests` de la base con la misma clave y las mismas variantes: lo
//     que no está registrado ahí el servidor no lo guarda. Ver admin-back/sql/2026-10-11_pruebas_ab.sql.
//  3. Deploy de main-front. Los resultados se ven en el admin, Analytics > Pruebas A/B.
//
// PARA TERMINARLA: sacar la entrada de acá (la cookie se limpia sola en la próxima visita) y
// ponerle `fin` a su fila de `ab_tests`.
//
// EL REPARTO es en partes iguales entre las variantes. Para mostrarle una variante riesgosa a
// poca gente primero, se repite la de control: ["a","a","a","a","a","a","a","a","a","b"] le da
// "b" a 1 de cada 10. (El chequeo de reparto del admin supone partes iguales: con esto va a
// avisar que está desparejo, y es lo esperado.)
//
// PARA PROBAR UNA VARIANTE A MANO: abrir la página con ?ab=<clave>:<variante>, por ejemplo
// /es/libros?ab=aal1:b. Queda marcado como prueba nuestra y no entra en los resultados.

/**
 * Las páginas donde puede correr una prueba, como expresión regular del path. El idioma es
 * opcional porque la web muestra /libros un instante antes de corregirlo a /es/libros.
 */
export const PAGINAS = {
  libros: "^/(?:[a-z]{2}/)?libros/?$",
  checkout: "^/(?:[a-z]{2}/)?checkout-pay/?$",
};

/**
 * `pagina` es donde el visitante ENTRA a la prueba: ahí se sortea y ahí cuenta como visitante.
 *
 * Las dos de hoy son pruebas en vacío: las dos variantes muestran exactamente lo mismo. Sirven
 * para comprobar el sistema antes de creerle (que el reparto dé mitad y mitad, y que las dos
 * mitades vendan lo mismo).
 */
export const PRUEBAS = [
  { clave: "aal1", pagina: "libros", variantes: ["a", "b"] },
  { clave: "aac1", pagina: "checkout", variantes: ["a", "b"] },
];

export const CLAVE_RE = /^[a-z0-9]{2,12}$/;
export const VARIANTE_RE = /^[a-z0-9]{1,8}$/;

/** El formato de la cookie entera, el mismo que revisa admin-back (App\Services\PruebasAb). */
export const COOKIE_RE =
  /^[A-Za-z0-9-]{8,40}~[a-z0-9]{2,12}:[a-z0-9]{1,8}(?:\.[a-z0-9]{2,12}:[a-z0-9]{1,8}){0,7}(?:~f)?$/;
